import AppServices from "./appservices";

class RateIterationService extends AppServices {

  sendEvaluation( obj ) {
    return this.request("/rate-evaluation", "POST", obj);
  }
}

export default RateIterationService;